import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { supabase } from "../config/supabaseClient";
import { startLoading, stopLoading } from "./commonSlice";
import { preloadStaticDataSources, clearStaticDataSourceCache } from "../constant/staticDataSources";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, { rejectWithValue,dispatch }) => {
    try {
      dispatch(startLoading());
      const { data, error } = await supabase.auth.signInWithPassword({
        email: email.trim()?.toLowerCase(),
        password,
      });
      dispatch(stopLoading());

      if (error) throw new Error(error.message);
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      clearStaticDataSourceCache();
      const { error } = await supabase.auth.signOut();
      
      if (error) throw new Error(error.message);
      return true;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        clearStaticDataSourceCache();
        preloadStaticDataSources().catch(err => {
          console.error('Error preloading static data sources:', err);
        });
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default authSlice.reducer;
